



































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { LayoutServiceBus } from "@/services/bus/layout.service";
import * as types from "@/store/types";
import AuthService from "@/services/api/auth.service";
import MenuComponent from "@/components/structure/Menu.vue";
import HeaderComponent from "@/components/structure/Header.vue";
import FooterComponent from "@/components/structure/Footer.vue";
import { ICurrentUser } from "@/models/auth/current.user";
import CurrentData from "@/models/auth/current.data";
import SideComponent from "@/models/shared/side.component";
import NotificationsComponent from "@/components/structure/Notifications.vue";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import * as AppNotification from "@/models/notifications/notification";

@Component({
  components: {
    MenuComponent,
    HeaderComponent,
    FooterComponent,
    NotificationsComponent
  }
})
export default class LayoutPage extends Vue {
  @Getter("identity") user?: ICurrentUser;
  @Watch("$route")
  onRouteChanged() {
    this.closeSideMenu();
  }
  @Watch("isSideOpen")
  onCloseSideMenu() {
    if (!this.isSideOpen) {
      this.bodyEl?.classList.remove("no-scroll");
    }
  }

  @Watch("isNotificationsOpen")
  onCloseNotificationMenu() {
    if (!this.isNotificationsOpen) {
      this.bodyEl?.classList.remove("no-scroll");
    }
  }

  authService: AuthService = new AuthService();
  isMenuOpen: boolean = false;
  isSideOpen: boolean = false;
  isNotificationsOpen: boolean = false;
  isAuthenticated: boolean = true;
  sideComponent: SideComponent | null = null;
  bodyEl: HTMLElement | null = null;
  isNotificationVisible: boolean = false;
  notificationTimeout: number = 5000;
  notificationColor: string = "info";
  notificationTitle: string | null = null;

  get CanRenderApp(): boolean {
    return this.isAuthenticated && this.user != null;
  }

  created() {
    this.bodyEl = document.getElementsByTagName("html")[0];
    NotificationServiceBus.$on(
      "showMessage",
      (notification: AppNotification.Notification) => {
        switch (notification.type) {
          case AppNotification.NotificationType.Success:
            this.notificationColor = "success";
            break;
          case AppNotification.NotificationType.Info:
            this.notificationColor = "info";
            break;
          case AppNotification.NotificationType.Error:
            this.notificationColor = "error";
            break;
          default:
            this.notificationColor = "info";
            break;
        }
        this.notificationTitle =
          notification.title + ": " + notification.description;
        this.isNotificationVisible = true;
      }
    );
    this.authService
      .Load()
      .then((response: CurrentData) => {
        this.currentLoaded(response);
      })
      .catch(() => this.currentNotLoaded());
  }

  currentLoaded(data: CurrentData) {
    this.$store.dispatch(types.LOGIN, data).then(() => {
      this.isAuthenticated = true;
    });

    LayoutServiceBus.$on("openSideMenu", (component: SideComponent) => {
      this.isSideOpen = true;
      this.bodyEl?.classList.add("no-scroll");
      this.sideComponent = component;
    });

    LayoutServiceBus.$on("closeSideMenu", () => {
      this.closeSideMenu();
    });

    LayoutServiceBus.$on("openNotifications", () => {
      this.isNotificationsOpen = true;
      this.bodyEl?.classList.add("no-scroll");
    });

    LayoutServiceBus.$on("closeNotifications", () => {
      this.isNotificationsOpen = false;
    });
  }

  currentNotLoaded() {
    this.$store.dispatch(types.LOGOUT).then(() => {
      this.authService.Logout();
      this.$router.replace("/login");
    });
  }

  menuToggle(isOpen: boolean) {
    this.isMenuOpen = isOpen;
  }

  notificationsToggle(): void {
    this.isNotificationsOpen = false;
  }

  closeSideMenu(): void {
    this.isSideOpen = false;
    this.sideComponent = null;
  }
}
